module.exports = __webpack_public_path__ + "static/media/note-icon.d43add3a.svg";